import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import { getOfferImageLink } from 'lib/image';
import { toAbsoluteLink, toOfferLink } from 'lib/links';
import {
  formatDynamicOfferPageDescription,
  formatOfferPageTitle,
} from 'lib/offerPage';

import OFFER from 'constants/offer';

const Head = ({
  aliasUrl = null,
  isIndexActive = true,
  offerCommentsCount = 0,
  offerCoupon,
  offerStatusName,
  offerPhoto,
  offerPrice,
  offerPriceType,
  offerTitle,
  storeDomain = null,
  storeName = null,
  referencePrices = null,
  reviewsCount = 0,
}) => {
  const description = formatDynamicOfferPageDescription({
    isFinishedOffer: offerStatusName === OFFER.STATUSES.FINISHED,
    offerTitle,
    offerPrice,
    offerPriceType,
    storeName,
    storeDomain,
    hasCoupon: !!offerCoupon,
    hasPriceHistory: referencePrices && referencePrices.length > 0,
    hasCommunityComments: offerCommentsCount > 0 || reviewsCount > 0,
    abTestHidePriceHistory: true,
  });
  const offerPageTitle = formatOfferPageTitle({
    offerPrice,
    offerPriceType,
    offerTitle,
  });

  return (
    <NextSeo
      canonical={aliasUrl ? toAbsoluteLink(toOfferLink(aliasUrl)) : null}
      description={description}
      nofollow={!isIndexActive}
      noindex={!isIndexActive}
      openGraph={{
        title: offerPageTitle,
        description: description,
        images: [
          {
            url: getOfferImageLink(offerPhoto, 268),
            alt: offerPageTitle,
            height: 300,
            width: 300,
          },
        ],
      }}
      title={offerPageTitle}
    />
  );
};

Head.propTypes = {
  aliasUrl: PropTypes.string,
  isIndexActive: PropTypes.bool,
  offerCommentsCount: PropTypes.number,
  offerCoupon: PropTypes.string.isRequired,
  offerStatusName: PropTypes.string.isRequired,
  offerPhoto: PropTypes.string.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
  offerTitle: PropTypes.string.isRequired,
  storeDomain: PropTypes.string,
  storeName: PropTypes.string,
  referencePrices: PropTypes.arrayOf(
    PropTypes.shape({
      price: PropTypes.number.isRequired,
      priceType: PropTypes.string.isRequired,
    })
  ),
  reviewsCount: PropTypes.number,
};

export default Head;
